import { createFileRoute, redirect } from "@tanstack/react-router";

import { DashboardPage } from "@/features/dashboard/DashboardPage";

export const Route = createFileRoute("/_app/dashboard")({
  beforeLoad: ({ context }) => {
    const allowed = context.info.edition === "local" ? Boolean(context.info.device) : context.me?.permissions.includes("dashboards.read");
    if (!allowed) {
      throw redirect({ to: "/worklist" });
    }
  },
  component: DashboardPage,
});
